import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Gotop from "../../components/gotop";
import JobList from "./JobList";
import CRHeader from "../../components/header/CRHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import { Helmet } from "react-helmet";


ViewJobs.propTypes = {};

function ViewJobs(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <Helmet>
				<title>Job/My-Jobs | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Job/My-Jobs | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
            <CRMobileHeader handleMobile={handleMobile} />
            <CRHeader clname="manageJob" handleMobile={handleMobile} />
               <div className="pt-70">
                <JobList />
                <Gotop />
            </div>
        </>
    );
}

export default ViewJobs;
